import { Box, useTheme } from '@mui/material';

import { SiteUnitDefaultIcon } from './icons';

export const SiteUnitCardImageDefault = () => {
  const theme = useTheme();
  return (
    <Box
      role="presentation"
      sx={{
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        backgroundColor: theme.palette.grey[100],
        aspectRatio: '3/2',
        width: '100%',
      }}
    >
      <Box sx={{ maxWidth: 'fit-content' }}>
        <SiteUnitDefaultIcon stroke={theme.palette.primary.main} />
      </Box>
    </Box>
  );
};
